import { render } from "./ReturnSupplierTemplate.vue?vue&type=template&id=d9d74772"
import script from "./ReturnSupplierTemplate.vue?vue&type=script&lang=js"
export * from "./ReturnSupplierTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__